import NewCommonServiceHero from "../../../common/NewCommonServices/NewCommonServiceHero";
import NewCommonServiceForm from "../../../common/NewCommonServices/NewCommonServiceForm";
import NewCommonMoreItService from "../../../common/NewCommonServices/NewCommonMoreItService";
import {
  animatedVideoIcon,
  socialMediaVideoIcon,
  youtubeVideoIcon,
  corporateVideoIcon,
  podcastVideoIcon,
} from "../../../../assets/icons/serviceIcon/index";
import { useEffect } from "react";

const items = [
  {
    name: "Product/Service Explainer Videos",
    text: "Simplify how your product/service works with engaging, easy-to-understand videos that drive clarity and faster customer decisions.",
  },
  {
    name: "FAQ & Support Videos",
    text: "Answer common customer questions through bite-sized videos that reduce support tickets and improve overall user satisfaction.",
  },
  {
    name: "Whiteboard Animation Videos",
    text: "Use hand-drawn illustrations on a white background to explain complex ideas in a simple, engaging and memorable way.",
  },
];

const otherService = [
  {
    icon: socialMediaVideoIcon,
    name: "Social Media Videos",
    des: "From raw videos to scroll-ready IG Reels and YT Shorts",
    path: "/social-media-videos",
  },
  {
    icon: youtubeVideoIcon,
    name: "YouTube Video Editing",
    des: "Long-form YouTube videos with clean cuts, flow, and branding.",
    path: "/youtube-video-editing",
  },
  {
    icon: corporateVideoIcon,
    name: "Corporate & Business Videos",
    des: "Polished business videos for presentations and internal brand communication",
    path: "/corporate-and-business-video",
  },
  {
    icon: podcastVideoIcon,
    name: "Podcast & Interview Editing",
    des: "Clean edits, smooth flow, and visuals that make content shine.",
    path: "/podcast-and-interview-editing",
  },
  {
    icon: animatedVideoIcon,
    name: "Animated Videos",
    des: "Engaging animated videos that simplify ideas and grab attention.",
    path: "/animated-videos",
  },
];
const TutorialVideo = () => {
  useEffect(() => {
    // Set Page Title
    document.title = "Explainer Video Services | Animated Videos by TechQilla";

    // --- Description ---
    let metaDescription = document.querySelector<HTMLMetaElement>(
      "meta[name='description']",
    );
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.name = "description";
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute(
      "content",
      "Create engaging explainer and tutorial videos that simplify complex ideas and boost brand communication and conversions.",
    );

    // --- Keywords ---
    let metaKeywords = document.querySelector<HTMLMetaElement>(
      "meta[name='keywords']",
    );
    if (!metaKeywords) {
      metaKeywords = document.createElement("meta");
      metaKeywords.name = "keywords";
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute("content", "Explainer Video Services");
    // --- Canonical ---
    let linkTag = document.querySelector<HTMLLinkElement>(
      "link[rel='canonical']",
    );
    if (!linkTag) {
      linkTag = document.createElement("link");
      linkTag.rel = "canonical";
      document.head.appendChild(linkTag);
    }
    linkTag.setAttribute(
      "href",
      "https://www.techqilla.com/explainer-tutorial-video",
    );
  }, []);

  return (
    <div className="">
      <NewCommonServiceHero
        colorHeading="Videos"
        description="We create explainer and tutorial videos that simplify complex ideas, engage your audience, and make your brand easier to understand, remember and trust - all in just a few minutes."
        heading="Explainer & Tutorial"
      />
      <NewCommonServiceForm title="Explainer & Tutorial Videos" items={items} />
      <NewCommonMoreItService items={otherService} />
    </div>
  );
};

export default TutorialVideo;
